// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__18ZN5","header":"MergedInvoice_header__2k1gM"};